export default {
  accessToken: import.meta.env.VITE_ROLLBAR_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: import.meta.env.VITE_ROLLBAR_ENVIRONMENT,
    client: {
      javascript: {
        // Must match the version the source maps were uploaded under in
        // vite.config.js, or Rollbar cannot symbolicate the stack traces.
        code_version: import.meta.env.VITE_APP_VERSION
      }
    }
  }
};
